import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { resendProjectMemberInvite } from '@/features/projects/shared/api/resend-project-member-invite';
import { getProjectMemberManagementSearchKey } from '@/features/projects/shared/hooks/use-search-project-member-management';

type Input = Parameters<typeof resendProjectMemberInvite>[0] & {
  projectId?: string;
};

export const useResendProjectMemberInviteMutation = (
  props?: UseMutationOptions<unknown, unknown, Input, unknown>,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...props,
    mutationFn: resendProjectMemberInvite,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: getProjectMemberManagementSearchKey({
          projectId: variables.projectId?.toString() || undefined,
        }),
      });
      props?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
